export default async function (context) {
	if (context.$cookie.get('token')) {
		const rolePermissions = context.store.state.internal['role-permissions'].rolePermissions
		if (!rolePermissions?.length) {
			await context.store.dispatch('internal/role-permissions/getRolePermissions')
		}
	}
}